<template>
  <div class="uk-position-relative uk-section uk-background-cover uk-background-blend-multiply" v-bind:class="feature.cssClass ? feature.cssClass : 'uk-section-medium uk-text-center uk-background-white'" v-bind:style="{ backgroundImage: feature?.image.large16x9 ? `url(${feature.image.large16x9})` : '' }">
      <div class="uk-container uk-container-small">
          <h1>{{feature.heading}}</h1>
          <p class="uk-text-lead" v-html="feature.body" v-if="feature.body" />

          <template v-if="feature.link">
            <a v-if="feature.openInNew" :href="feature.link" class="uk-button uk-button-primary theme-button" :class="`button-${feature.buttonClass.toLowerCase()}`" target="_blank">{{feature.buttonLabel}}</a>
            <router-link v-else :to="feature.link" class="uk-button uk-button-primary theme-button" :class="`button-${feature.buttonClass.toLowerCase()}`">{{feature.buttonLabel}}</router-link>
        </template>
      </div>
  </div>
</template>

<script>
export default {
    props: ['feature']
}
</script>
